export default __webpack_public_path__ + "static/media/add-full.f810beb7.svg";